export default __webpack_public_path__ + "static/media/exclamation_yellow_flat_icon.35f11391.svg";